// extracted by mini-css-extract-plugin
export default {"arrow":"Arrow_arrow__-lk4s","arrow-8":"Arrow_arrow-8__a-6uu"};